import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './appFooter.scss';

const AppFooter: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="AppFooter-Wrapper">
      <p>{t('app.footer')}</p>
    </div>
  );
};

export default AppFooter;
